import { createSlice } from '@reduxjs/toolkit';
import { IResource } from '../../../../dto';
import { setResource } from '../actions';
import { MN_RESOURCES, TYPE_ELEMENT } from '../../../../common';

export interface ResourceState {
  data: IResource | null;
  loading: boolean;
  error: string | null;
}

const initialState: ResourceState = {
  data: null,
  loading: false,
  error: null,
};

export const resourceSlice = createSlice({
  name: `${MN_RESOURCES}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setResource, (state, { payload }) => {
      state.data = payload;
    });
  },
});
